import * as React from 'react'
import { Link as BaseLink} from 'react-router-dom'
import {Grid, Link, Typography, Container, Box} from '@mui/material'
import { dateFormatted } from '../../misc/dates'





export const MainFooter = () =>{

return(
    <footer style={{backgroundColor: '#565656', width: '100%', height: 'auto', minHeight: 'auto', bottom: 0, left:0, margin:0, display: 'flex' }}>
 
<Container maxWidth='xl'>
    <Box backgroundColor='#565656' >        
     <Grid container direction='row' sx={{justifyContent:'space-evenly'}}>
       <Grid size={{xs: 12, sm: 10, lg: 4}}> 
        <Grid container direction='column'sx={{justifyContent:'space-evenly'}}>
            <Grid>
                <Typography variant='body1' sx={{ color: 'white'}} align='center'><strong><u>Other Links</u></strong> </Typography>
            </Grid>
            <Grid textAlign='center' >
                 <Link key={'../FAQ'} component={BaseLink} to={'/FAQ'} variant='body1'color='white' underline='hover'>Frequently Asked Questions</Link>
            </Grid>
            <Grid textAlign='center'>
                <Link key={'../privacy-policy'} align='center' component={BaseLink} to={'/privacy-policy'} variant='body1'color='white' underline='hover'>Privacy Policy</Link>
            </Grid>
            <Grid textAlign='center'>
                <Link key={'../termsandconditions'} align='center' component={BaseLink} to={'/termsandconditions'} variant='body1'color='white' underline='hover'>Terms and Conditions</Link>
            </Grid>
            <Grid textAlign='center'>
                <Link key={'../refund-policy'} align='center' component={BaseLink} to={'/refund-policy'} variant='body1'color='white' underline='hover'>Refund Policy</Link>
            </Grid>
        </Grid> 
     </Grid>
     <Grid size={{xs: 12, sm: 10, lg: 4}}> 
        <Grid container direction='column' sx={{justifyContent:'space-evenly'}}>
            <Grid>
                <Typography  variant='body1'  sx={{color: 'white'}}><strong><u>Contact Info</u></strong></Typography>
            </Grid>
            <Grid>
                <Typography variant='body1'  sx={{color: 'white'}}>Phone: 1-866-465-6269 </Typography>
            </Grid>
            <Grid>
                <Typography variant='body2' sx={{color: 'white'}}> Call Center Hours: Mon-Fri 8:00 am - 5:00 pm PST</Typography>
            </Grid>
            <Grid>
                <Typography variant='body1' sx={{color: 'white'}}>Address: PO Box 15333, Spokane Valley, WA 99215-333 </Typography>
            </Grid>
            
        </Grid>
     </Grid>
     <Grid size={{xs: 12, sm: 10, lg: 3}}>
        <Grid container direction='column' sx={{justifyContent:'flex-end'}}>
            <Grid sx={{display:{xs: "none", sm: "flex"}}}>             
                <img src="nmsfootersvg.svg" height='75' alt='footerlogo' />
            </Grid>
        </Grid>
    </Grid>
 </Grid>
  <Grid container direction='row' sx={{alignContent:'space-evenly', justifyContent:'space-evenly'}}></Grid>
    <Grid size={{xs: 12}} >
             <Typography sx={{ backgroundColor: '#565656', color: 'white' }} align='center' variant='body1'>©2016-{dateFormatted.thisYear}, NameMySettlement.com and any parent companies, All rights reserved.</Typography>
    </Grid>

</Box>
</Container>
</footer>


)

}

export const UserFooter = ({baseURL}) =>{

    
    const imgsource = baseURL + '/nmsfootersvg.svg'
    return(
        <footer style={{backgroundColor: '#565656', width: '100%', height: 'auto', minHeight: 'auto', bottom: 0, left:0, margin:0,}}>
     
    <Container maxWidth='xl'>
        <Box backgroundColor='#565656' >        
         <Grid container direction='row' sx={{justifyContent:'space-evenly'}}>
           <Grid size={{xs: 12, sm: 10, lg: 4}}> 
            <Grid container direction='column' sx={{justifyContent: 'space-evenly'}}>
                <Grid>
                    <Typography variant='body1' align='center' sx={{color: 'white'}}><strong><u>Other Links</u></strong> </Typography>
                </Grid>
                <Grid textAlign='center' >
                     <Link key={'../user/FAQ'} component={BaseLink} to={'/user/FAQ'} variant='body1'color='white' underline='hover'>Frequently Asked Questions</Link>
                </Grid>
                <Grid textAlign='center'>
                    <Link key={'../user/privacy-policy'} align='center' component={BaseLink} to={'/user/privacy-policy'} variant='body1'color='white' underline='hover'>Privacy Policy</Link>
                </Grid>
                <Grid textAlign='center'>
                    <Link key={'../user/termsandconditions'} align='center' component={BaseLink} to={'/user/termsandconditions'} variant='body1'color='white' underline='hover'>Terms and Conditions</Link>
                </Grid>
                <Grid textAlign='center'>
                    <Link key={'../user/refund-policy'} align='center' component={BaseLink} to={'/user/refund-policy'} variant='body1'color='white' underline='hover'>Refund Policy</Link>
                </Grid>
            </Grid> 
         </Grid>
        <Grid size={{xs: 12, sm: 10, lg: 4}}> 
        <Grid container direction='column' sx={{justifyContent:'space-evenly'}}>
            <Grid>
                <Typography  variant='body1'  sx={{color: 'white'}}><strong><u>Contact Info</u></strong></Typography>
            </Grid>
            <Grid>
                <Typography variant='body1'  sx={{color: 'white'}}>Phone: 1-866-465-6269 </Typography>
            </Grid>
            <Grid>
                <Typography variant='body2' sx={{color: 'white'}}> Call Center Hours: Mon-Fri 8:00 am - 5:00 pm PST</Typography>
            </Grid>
            <Grid>
                <Typography variant='body1' sx={{color: 'white'}}>Address: PO Box 15333, Spokane Valley, WA 99215-333 </Typography>
            </Grid>
            
        </Grid>
     </Grid>
         <Grid size={{xs: 12, sm: 10, lg: 3}}>
            <Grid container direction='column' sx={{justifyContent:'flex-end'}}>
                
                <Grid sx={{display: {xs: 'none', sm: 'flex'}}}>             
                    <img src={imgsource} height='75' alt='footerlogo' />
                </Grid>
                
                
            </Grid>
        </Grid>
     </Grid>
      <Grid container direction='row' sx={{alignContent:'space-evenly', justifyContent:'space-evenly'}}></Grid>
        <Grid size={{xs: 12}}>
                 <Typography sx={{ backgroundColor: '#565656', color: 'white' }} align='center' variant='body1' >©2016-{dateFormatted.thisYear}, NameMySettlement.com and any parent companies, All rights reserved.</Typography>
        </Grid>
    
    </Box>
    </Container>
    </footer>
    
    
    )
    
    }

export const AdminFooter = (baseURL) =>{
    
    
    const imgsource = baseURL.baseURL + '/nmsfootersvg.svg'
    


    return(
    <footer style={{backgroundColor: '#565656', width: '100%', height: 'auto', minHeight: 'auto', bottom: 0, left:0, margin:0,}}>
     <Container maxWidth='xl'>
        <Box backgroundColor='#565656' >        
         <Grid container direction='row' sx={{justifyContent:'space-evenly'}}>
           
         <Grid size={{xs: 12, sm: 10, lg: 4}}> 
        <Grid container direction='column' sx={{justifyContent:'space-evenly', alignItems: 'center'}}>
            <Grid>
                <Typography  variant='body1' sx={{color: 'white'}} ><strong><u>Contact Info</u></strong></Typography>
            </Grid>
            <Grid>
                <Typography variant='body1' sx={{color: 'white'}} >Phone: 1-866-465-6269 </Typography>
            </Grid>
            <Grid>
                <Typography variant='body2' sx={{color: 'white'}}> Call Center Hours: Mon-Fri 8:00 am - 5:00 pm PST</Typography>
            </Grid>
            <Grid>
                <Typography variant='body1' sx={{color: 'white'}} >Address: PO Box 15333, Spokane Valley, WA 99215-333 </Typography>
            </Grid>
            
        </Grid>
     </Grid>
         <Grid size={{xs: 12, sm: 10, lg: 3}}>
            <Grid container direction='column' sx={{justifyContent:'flex-end'}}>
                
                <Grid sx={{display: {xs: 'none', sm: 'flex'}}}>             
                    <img src={imgsource} height='75' alt='footerlogo' />
                </Grid>
                
            
            </Grid>
        </Grid>
     </Grid>
      <Grid container direction='row' sx={{alignContent:'space-evenly', justifyContent:'space-evenly'}} ></Grid>
        <Grid size={{xs: 12}}>
                 <Typography sx={{ backgroundColor: '#565656', color: 'white'}} align='center' variant='body1' color='white'>©2016-{dateFormatted.thisYear}, NameMySettlement.com and any parent companies, All rights reserved.</Typography>
        </Grid>
    
    </Box>
    </Container>
    
    </footer>
    )
}